export default class LaneFreightMatchingSerializer {
  static serialize(data) {
    return {
      orderId: data.orderId,
      mode: data.mode,
      orderWeight: data.orderWeight,
      targetPay: data.targetPay,
      maxPay: data.maxPay,
      customerId: data.customerId,
      customerName: data.customerName,
      milesFromOrigin: data.milesFromOrigin,
      milesFromDestination: data.milesFromDestination,
      originCityName: data.originCity,
      originState: data.originState,
      originSchedArriveEarly: data.originSchedArriveEarly,
      originSchedArriveLate: data.originSchedArriveLate,
      destinationCityName: data.destinationCity,
      destinationState: data.destinationState,
      destinationSchedArriveEarly: data.destinationSchedArriveEarly,
      destinationSchedArriveLate: data.destinationSchedArriveLate,
      commodity: data.commodity,
      movementId: data.movementId,
      carrierOriginCity: data.carrierOriginCity,
      carrierOriginState: data.carrierOriginState
    };
  }

  static deSerialize(data) {
    return {
      orderId: data.orderId,
      mode: data.mode,
      orderWeight: data.orderWeight,
      targetPay: data.targetPay,
      maxPay: data.maxPay,
      customerId: data.customerId,
      customerName: data.customerName,
      milesFromOrigin: data.milesFromOrigin,
      milesFromDestination: data.milesFromDestination,
      originCity: data.originCityName,
      originState: data.originState,
      originSchedArriveEarly: data.originSchedArriveEarly,
      originSchedArriveLate: data.originSchedArriveLate,
      destinationCity: data.destinationCityName,
      destinationState: data.destinationState,
      destinationSchedArriveEarly: data.destinationSchedArriveEarly,
      destinationSchedArriveLate: data.destinationSchedArriveLate,
      commodity: data.commodity,
      movementId: data.movementId,
      carrierOriginCity: data.carrierOriginCity,
      carrierOriginState: data.carrierOriginState
    };
  }
}